module.exports = __webpack_public_path__ + "img/thirdSide.87f0312c.svg";